import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import Parallax from 'react-rellax'
import FeaturedWorkItem from '../item/featuredWorkItem'
import { useViewport } from '../../../containers/useViewport'
import './featuredWorkBlock.css'

const FeaturedWorkBlock = ({ data }) => {
  const { width } = useViewport()

  const isMobile = width / 16 < 48

  return (
    <section className="featuredWork">
      <div className="inner">
        <Parallax speed={-2.75} className="intro">
          {data.content && data.content.title && <h2>{data.content.title}</h2>}
          {data.content && data.content.leader && <strong>{data.content.leader}</strong>}
        </Parallax>
        {data.items &&
          data.items.map((item, index) => (
            <FeaturedWorkItem
              data={{
                content: item.caseStudy,
                index: index,
              }}
              key={`item-${index}`}
            ></FeaturedWorkItem>
          ))}
      </div>
      <Parallax speed={isMobile ? -1 : -1.5} className="blockFoot">
        <Link to="/work" className="blockLink">
          View all work
        </Link>
      </Parallax>
    </section>
  )
}

FeaturedWorkItem.propTypes = {
  data: PropTypes.object,
}

FeaturedWorkItem.defaultProps = {
  data: {
    content: {
      title: 'Featured work',
      leader: 'Active Matter is an experience design & innovation agency',
    },
    items: [],
  },
}

export default FeaturedWorkBlock
